import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

interface BlockCreateModalState {
	isActive: boolean;
	source: string;
}

const initialState: BlockCreateModalState = {
	isActive: false,
	source: '',
};

const NAME = 'BLOCK_CREATE_MODAL_STORE';

const BlockCreateModalStore = createStore({
	name: NAME,
	initialState,
	actions: {
		showBlockCreateModal:
			(source: any): (({ setState }: StoreActionApi<BlockCreateModalState>) => void) =>
			({ setState }) => {
				setState({ isActive: true, source });
			},
		onBlockCreateModalClose:
			(): (({ setState }: StoreActionApi<BlockCreateModalState>) => void) =>
			({ setState }) => {
				setState({ isActive: false, source: '' });
			},
	},
});

export const useBlockCreateModalStore: HookFunction<
	BlockCreateModalState,
	BoundActions<
		BlockCreateModalState,
		{
			showBlockCreateModal: (
				source: any,
			) => ({ setState }: StoreActionApi<BlockCreateModalState>) => void;
			onBlockCreateModalClose: () => ({ setState }: StoreActionApi<BlockCreateModalState>) => void;
		}
	>,
	void
> = createHook(BlockCreateModalStore);

export const useBlockCreateModalActions: HookActionsFunction<
	BoundActions<
		BlockCreateModalState,
		{
			showBlockCreateModal: (
				source: any,
			) => ({ setState }: StoreActionApi<BlockCreateModalState>) => void;
			onBlockCreateModalClose: () => ({ setState }: StoreActionApi<BlockCreateModalState>) => void;
		}
	>
> = createActionsHook(BlockCreateModalStore);
